// 条件で絞り込み
export const SCOUT_SERVICE_JOBS_FILTER_TYPE = {
  DEFAULT: 0, // 初期設定
  ALL: 5, // すべて表示
  RECRUITING: 1, // 募集中
  CLOSED_RECRUITING: 2, // 募集終了
  NEAR_DEADLINE: 3, // 締切間近
  INTERVIEW: 4, // 面接確約
} as const;

// 条件で並び替え
export const SCOUT_SERVICE_JOBS_SORT_TYPE = {
  DEFAULT: 0, // 初期設定
  NEW_SAVE_DATA: 1, // 保存日が新しい順
  OLD_SAVE_DATA: 2, // 保存日が古い順
  NEAR_DEADLINE: 3, // 締切間近
} as const;

export type ScoutServiceJobFilterType =
  (typeof SCOUT_SERVICE_JOBS_FILTER_TYPE)[keyof typeof SCOUT_SERVICE_JOBS_FILTER_TYPE];

export type ScoutServiceJobSortType =
  (typeof SCOUT_SERVICE_JOBS_SORT_TYPE)[keyof typeof SCOUT_SERVICE_JOBS_SORT_TYPE];

// OSスカウト区分
export const OSSCFL_LIST = [
  '1', // ARCS掘り起こし
  '2', // お知らせメール
  '3', // OSスカウト
  '4', // アプローチメール
  '12', // オープンリソース／お知らせメール／面接確約
  '13', // オープンリソース／検討中リスト(マイページ)／面接確約
  '22', // 紹介プラス／お知らせメール／面接確約
  '23', // 紹介プラス／検討中リスト(マイページ)／面接確約
  '24', // 紹介プラス／アプローチメール／面接確約
  '32', // 課金／お知らせメール／面接確約
  '33', // 課金／検討中リスト(マイページ)／面接確約
  '41', // dodaRequest
] as const;

export const IGNORE_SCOUTLIST_ID = [
  /** スカウト制御を含む画面表示を受諾するIDの最大値 */
  '999999999',
  /** OSスカウトのARCS掘り起こしスカウトリストID */
  '999999901',
  /** OSスカウトのお知らせメールスカウトリストID */
  '999999902',
  /** OSスカウトの検討中リストスカウトリストID */
  '999999903',
  /** OSスカウトのアプローチメールスカウトリストID */
  '999999904',
  /** OSスカウトのお知らせ配信メール */
  '999999922',
  /** OSスカウトの検討中リスト */
  '999999923',
  /** OSスカウトのアプローチメール */
  '999999924',
  /** 課金スカウトのお知らせメールスカウトリストID(面接確約) */
  '999999932',
  /** 課金スカウトの検討中リストスカウトリストID(面接確約) */
  '999999933',
  /** ORスカウトのお知らせメールスカウトリストID(面接確約) */
  '999999912',
  /** ORスカウトの検討中リストスカウトリストID(面接確約) */
  '999999913',
  /** dodaRequestのお知らせメールスカウトリストID */
  '999999941',
  /** プラスAI配信 */
  '888888888',
  /** 検証環境にのみリクエストが来ている */
  '8888888888',
  /** スカウトId（scoutId）=０というデータは存在しない */
  '0',
] as const;
